<div class="popup-container" [ngStyle]="{top: position.top, left: position.left}">
    <h4>{{ cliente?.name }}</h4>
    <div *ngIf="cliente?.subRoutes?.length > 0">
        <h6>Subrutas Asignadas:</h6>
        <ul>
            <li *ngFor="let subRoute of cliente.subRoutes">
                <strong>{{ subRoute.name }}</strong>
            </li>
        </ul>
    </div>

    <div *ngIf="cliente?.subRoutes?.length === 0">
        <p>No tiene subrutas asignadas</p>
    </div>
</div>
